import { FormGroup } from '@angular/forms';
import { allLocalesTextFilledValidator, hasWorkflowLocaleText } from './workflow-locale-text.util';

export type DelayedWarningMessageType = 'default' | 'custom';

/**
 * Mutación del FormGroup de aviso diferido (NIF-845).
 * Misma semántica que la región DELAYED_PROCESS del orquestador.
 */
export function updateDelayedProcessValidationState(params: {
	warningTextType: DelayedWarningMessageType;
	delayedTextGroup: FormGroup;
	allowedLanguages: readonly string[];
	applyingWorkflowDetail: boolean;
	delayedWarningCustomTextCache: Record<string, string>;
	lastDelayedWarningMessageType: DelayedWarningMessageType;
	getDelayedWarningDefaultTextMap: (locales: readonly string[]) => Record<string, string>;
	getDelayedWarningEmptyTextMap: (locales: readonly string[]) => Record<string, string>;
}): {
	delayedWarningCustomTextCache: Record<string, string>;
	lastDelayedWarningMessageType: DelayedWarningMessageType;
} {
	const warningActive = true;
	const {
		warningTextType,
		delayedTextGroup,
		allowedLanguages,
		applyingWorkflowDetail,
		getDelayedWarningDefaultTextMap,
		getDelayedWarningEmptyTextMap,
	} = params;
	let { delayedWarningCustomTextCache, lastDelayedWarningMessageType } = params;
	const currentWarningText = delayedTextGroup.getRawValue() as Record<string, string>;
	const shouldEnableText = Boolean(warningActive) && warningTextType === 'custom';
	const shouldRequireText = shouldEnableText;

	if (applyingWorkflowDetail) {
		if (shouldEnableText) {
			delayedTextGroup.enable({ emitEvent: false });
		} else {
			delayedTextGroup.disable({ emitEvent: false });
		}
		delayedTextGroup.setValidators(shouldRequireText ? [allLocalesTextFilledValidator()] : []);
		delayedTextGroup.updateValueAndValidity({ emitEvent: false });
		lastDelayedWarningMessageType = warningTextType;
		return { delayedWarningCustomTextCache, lastDelayedWarningMessageType };
	}

	if (warningTextType !== lastDelayedWarningMessageType) {
		if (warningTextType === 'default') {
			delayedWarningCustomTextCache = { ...currentWarningText };
		}
		if (warningTextType === 'custom') {
			const customTextToRestore = hasWorkflowLocaleText(delayedWarningCustomTextCache)
				? delayedWarningCustomTextCache
				: getDelayedWarningEmptyTextMap(allowedLanguages);
			delayedTextGroup.patchValue(customTextToRestore, { emitEvent: false });
		}
		lastDelayedWarningMessageType = warningTextType;
	}

	if (shouldEnableText) {
		delayedTextGroup.enable({ emitEvent: false });
	} else {
		delayedTextGroup.disable({ emitEvent: false });
	}
	delayedTextGroup.setValidators(shouldRequireText ? [allLocalesTextFilledValidator()] : []);
	if (warningActive && warningTextType === 'default') {
		delayedTextGroup.patchValue(getDelayedWarningDefaultTextMap(allowedLanguages), {
			emitEvent: false,
		});
	}
	delayedTextGroup.updateValueAndValidity({ emitEvent: false });
	return { delayedWarningCustomTextCache, lastDelayedWarningMessageType };
}
